<template>
  <div class="tablet-info">
    <a-form-model
      class="tablet-form"
      ref="tabletForm"
      label-align="left"
      layout="horizontal"
      :model="form"
      :rules="rules"
    >
      <a-form-model-item
        label="关系"
        prop="relation"
        :label-col="labelCol"
        :wrapper-col="wrapperCol"
        v-if="relation"
      >
        <a-select
          v-model="form.relation"
          :options="
            buddhism.getBuddhismTypeOptions(buddhism.buddhismRelationList)
          "
          placeholder="请选择关系"
          style="width: 100%"
        ></a-select>
      </a-form-model-item>
      <a-form-model-item
        label="牌位"
        prop="personList"
        :label-col="labelCol"
        :wrapper-col="{ span: 20 }"
        v-if="personNumber > 0"
      >
        <div
          class="tablet-person-item"
          v-for="(person, i) in form.personList"
          :key="i"
        >
          <form-area
            :ref="`personForm${i}`"
            layout="inline"
            hide-btn
            link
            :items="tabletConfig.personItems"
            :entity="person"
          >
          </form-area>
          <a-icon
            class="tablet-person-remove"
            type="close-circle"
            theme="filled"
            @click="removeItem(i, 'person')"
            v-if="form.personList.length > 1"
          />
        </div>
        <a-space
          class="add-tablet-item"
          @click="addItem('person')"
          v-show="form.personList.length < personNumber"
        >
          <a-icon type="plus" />
          <span>添加人员</span>
        </a-space>
      </a-form-model-item>
      <a-form-model-item
        label="阳上"
        prop="posterityList"
        :label-col="labelCol"
        :wrapper-col="{ span: 20 }"
        v-if="posterityNumber > 0"
      >
        <div
          class="tablet-person-item"
          v-for="(p, i) in form.posterityList"
          :key="i"
        >
          <form-area
            :ref="`posterityForm${i}`"
            layout="inline"
            hide-btn
            link
            :items="tabletConfig.posterityItems"
            :entity="p"
          >
          </form-area>
          <a-icon
            class="tablet-person-remove"
            type="close-circle"
            theme="filled"
            @click="removeItem(i, 'posterity')"
            v-if="form.posterityList.length > 1"
          />
        </div>
        <a-space
          class="add-tablet-item"
          @click="addItem('posterity')"
          v-show="form.posterityList.length < posterityNumber"
        >
          <a-icon type="plus" />
          <span>添加人员</span>
        </a-space>
      </a-form-model-item>
    </a-form-model>
  </div>
</template>

<script>
import * as buddhism from "../../../common/buddha/buddhism";
import city from "../../../common/constant/city";
import { clone } from "../../../common/js/tool";
export default {
  name: "tablet-info",
  model: {
    event: "change",
  },
  props: {
    entity: Object,
    value: [String, Object],
    labelCol: {
      type: Object,
      default: () => ({ span: 4 }),
    },
    wrapperCol: {
      type: Object,
      default: () => ({ span: 8 }),
    },
  },
  data() {
    return {
      form: {
        personList: [],
        posterityList: [],
      },
      buddhism,
      city,
      rules: {
        relation: [
          { required: true, message: "请选择关系", trigger: "change" },
        ],
        person: [
          { required: true, message: "请填写牌位信息", trigger: "change" },
        ],
        posterity: [
          { required: true, message: "请填写阳上信息", trigger: "change" },
        ],
      },
    };
  },
  computed: {
    // 是否需要选择关系
    relation() {
      return buddhism.hasRelation(this.entity);
    },
    // 牌位信息填写配置
    tabletConfig() {
      let entity = { ...this.entity };
      if (entity) {
        entity.tabletInfo = this.form;
      } else {
        entity = { tabletInfo: this.form };
      }
      return buddhism.getTabletConfig(entity, this.relation);
    },
    personNumber() {
      let conf = this.tabletConfig;
      return conf && conf.person ? conf.person.num : 0;
    },
    posterityNumber() {
      let conf = this.tabletConfig;
      return conf && conf.posterity ? conf.posterity.num : 0;
    },
  },
  watch: {
    personNumber() {
      this.setList("person");
    },
    posterityNumber() {
      this.setList("posterity");
    },
    value() {
      this.init();
    },
  },
  created() {
    this.init();
  },
  methods: {
    init() {
      let value = this.value;
      if (value) {
        if (typeof value === "string") {
          try {
            value = JSON.parse(value);
          } catch (e) {
            console.error(e);
            value = {
              personList: [],
              posterityList: [],
            };
          }
        }
        this.form = clone(value);
      } else {
        this.setList("person");
        this.setList("posterity");
      }
    },
    setList(type) {
      let num = this[`${type}Number`];
      let list = this.form[`${type}List`];
      if (list.length > num) {
        list = list.slice(0, num);
      } else if (list.length < num) {
        list = list.concat(
          new Array(num - list.length).fill(0).map(() => {
            return {};
          })
        );
      }
      this.$set(this.form, `${type}List`, list);
    },
    addItem(type) {
      let num = this.tabletConfig[type].num;
      let list = this.form[`${type}List`];
      if (list.length < num) {
        list.push({});
      } else {
        this.$message.warning(`最多只能添加${num}个`);
      }
    },
    removeItem(i, type) {
      this.form[`${type}List`].splice(i, 1);
    },
    checkForm() {
      console.log("checkForm");
      return Promise.all([this.checkOther(), this.checkTablet()]).then(
        (res) => {
          let form = res[0];
          let list = res[1];
          form.personList = list[0];
          form.posterityList = list[1];
          return form;
        }
      );
    },
    checkOther() {
      console.log("checkOther");
      return new Promise((resolve, reject) => {
        this.$refs.tabletForm.validate((valid) => {
          if (valid) {
            resolve(this.form);
          } else {
            reject("form error");
          }
        });
      });
    },
    checkFormList(type) {
      let pro = this.form[`${type}List`].map((item, index) => {
        let form = this.$refs[`${type}Form${index}`];
        if (form[0]) {
          return form[0].handleConfirm();
        }
      });
      return Promise.all(pro);
    },
    checkTablet() {
      console.log("checkTablet");
      let pro = [this.checkFormList("person"), this.checkFormList("posterity")];
      return Promise.all(pro);
    },
  },
};
</script>

<style scoped lang="less">
.add-tablet-item {
  color: @primary-color;
  cursor: pointer;
}
.tablet-person-item {
  position: relative;
}
.tablet-person-remove {
  position: absolute;
  top: 11px;
  right: 0;
  width: 18px;
  height: 18px;
  font-size: 18px;
  color: @text-color-secondary;
  cursor: pointer;
}
</style>
